import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const h = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const STEPS = ['Klub ma\'lumotlari', 'Egasi', 'Obuna', 'Tasdiqlash'];

const Field = ({ label, ...props }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={{ display: 'block', fontSize: 12, color: 'var(--text3)', marginBottom: 6 }}>{label}</label>
    <input {...props} style={{
      width: '100%', padding: '10px 14px', background: 'var(--bg2)',
      border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text)',
      fontSize: 13, boxSizing: 'border-box',
    }} />
  </div>
);

export default function SuperCreateLab() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const [form, setForm] = useState({
    lab_name: '', city: '', address: '', computers_count: 10,
    owner_name: '', owner_phone: '', owner_email: '', owner_password: '',
    plan: 'monthly', trial: false,
  });

  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const submit = async () => {
    setLoading(true);
    setError('');
    try {
      const body = {
        owner: {
          name: form.owner_name,
          phone: form.owner_phone,
          email: form.owner_email || undefined,
          password: form.owner_password || undefined,
        },
        lab: {
          name: form.lab_name,
          address: [form.city, form.address].filter(Boolean).join(', '),
          computers_count: form.computers_count,
        },
        subscription: form.trial ? {} : { plan_id: form.plan, months: 1 },
      };
      const r = await axios.post(`${API}/super/labs`, body, h());
      setResult(r.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Xatolik yuz berdi');
    }
    setLoading(false);
  };

  if (result) {
    return (
      <div style={{ maxWidth: 500, margin: '0 auto', textAlign: 'center', paddingTop: 40 }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>✅</div>
        <div style={{ fontSize: 22, fontWeight: 900, color: '#10b981', marginBottom: 8 }}>Klub muvaffaqiyatli yaratildi!</div>
        <div style={{ background: 'var(--bg2)', borderRadius: 14, padding: 24, border: '1px solid #10b981', marginBottom: 24, textAlign: 'left' }}>
          {[
            ['Klub nomi', result.lab?.name],
            ['Egasi', result.owner?.name],
            ['Email', result.owner?.email],
            ['Parol', result.generated_password || '(kiritilgan parol)'],
            ['Kompyuterlar', result.lab?.computers_count + ' ta (yaratildi)'],
          ].map(([k, v]) => (
            <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <span style={{ color: 'var(--text3)', fontSize: 13 }}>{k}</span>
              <span style={{ fontWeight: 700, fontSize: 13 }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button onClick={() => navigate(`/super/labs/${result.lab?.id}`)} style={{
            padding: '10px 24px', borderRadius: 10, cursor: 'pointer', fontWeight: 700,
            background: 'rgba(245,158,11,0.15)', border: '1px solid #f59e0b', color: '#f59e0b',
          }}>Klubni ko'rish →</button>
          <button onClick={() => navigate('/super/labs')} style={{
            padding: '10px 24px', borderRadius: 10, cursor: 'pointer', fontWeight: 700,
            background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text2)',
          }}>Barcha klublar</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 600 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 28 }}>
        <button onClick={() => navigate('/super/labs')} style={{
          background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)',
          padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
        }}>← Orqaga</button>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, color: '#f59e0b' }}>➕ Yangi klub yaratish</div>
        </div>
      </div>

      {/* Steps */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 32 }}>
        {STEPS.map((s, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%', fontWeight: 800, fontSize: 14,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: i < step ? '#10b981' : i === step ? '#f59e0b' : 'var(--bg2)',
              color: i <= step ? '#000' : 'var(--text3)',
              border: `2px solid ${i < step ? '#10b981' : i === step ? '#f59e0b' : 'var(--border)'}`,
            }}>{i < step ? '✓' : i + 1}</div>
            <div style={{ fontSize: 10, marginTop: 6, color: i === step ? '#f59e0b' : 'var(--text3)', textAlign: 'center' }}>{s}</div>
          </div>
        ))}
      </div>

      {error && <div style={{ padding: '12px 16px', borderRadius: 10, marginBottom: 16, background: 'rgba(239,68,68,0.1)', border: '1px solid #ef4444', color: '#ef4444' }}>{error}</div>}

      <div style={{ background: 'var(--bg2)', borderRadius: 14, padding: 28, border: '1px solid var(--border)', marginBottom: 24 }}>
        {/* Step 0: Klub */}
        {step === 0 && (
          <>
            <Field label="Klub nomi *" value={form.lab_name} onChange={e => set('lab_name', e.target.value)} placeholder="CyberNet Chilonzor" />
            <Field label="Shahar" value={form.city} onChange={e => set('city', e.target.value)} placeholder="Toshkent" />
            <Field label="Manzil" value={form.address} onChange={e => set('address', e.target.value)} placeholder="Chilonzor ko'chasi 5" />
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text3)', marginBottom: 6 }}>Kompyuterlar soni</label>
              <input
                type="number" min={1} max={200} value={form.computers_count}
                onChange={e => set('computers_count', parseInt(e.target.value) || 1)}
                style={{ width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text)', fontSize: 13, boxSizing: 'border-box' }}
              />
            </div>
          </>
        )}

        {/* Step 1: Egasi */}
        {step === 1 && (
          <>
            <Field label="Ism Familiya *" value={form.owner_name} onChange={e => set('owner_name', e.target.value)} placeholder="Abdullayev Jahongir" />
            <Field label="Telefon *" value={form.owner_phone} onChange={e => set('owner_phone', e.target.value)} placeholder="998901234567" type="tel" />
            <Field label="Email" value={form.owner_email} onChange={e => set('owner_email', e.target.value)} placeholder="jahongir@mail.uz" type="email" />
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text3)', marginBottom: 6 }}>Parol (bo'sh qoldiring — avtomatik yaratiladi)</label>
              <input
                value={form.owner_password} onChange={e => set('owner_password', e.target.value)}
                placeholder="Ixtiyoriy"
                type="password"
                style={{ width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text)', fontSize: 13, boxSizing: 'border-box' }}
              />
            </div>
          </>
        )}

        {/* Step 2: Obuna */}
        {step === 2 && (
          <>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>Obuna rejasi</label>
              {[
                { value: 'monthly', label: 'Oylik', sub: 'Har oy to\'lov' },
                { value: 'quarterly', label: 'Kvartal', sub: '3 oyga' },
                { value: 'yearly', label: 'Yillik', sub: '12 oyga' },
              ].map(opt => (
                <div
                  key={opt.value}
                  onClick={() => set('plan', opt.value)}
                  style={{
                    padding: '14px 18px', borderRadius: 10, marginBottom: 8, cursor: 'pointer',
                    background: form.plan === opt.value ? 'rgba(245,158,11,0.1)' : 'var(--bg)',
                    border: `1px solid ${form.plan === opt.value ? '#f59e0b' : 'var(--border)'}`,
                  }}
                >
                  <span style={{ fontWeight: 700, color: form.plan === opt.value ? '#f59e0b' : 'var(--text)' }}>{opt.label}</span>
                  <span style={{ fontSize: 12, color: 'var(--text3)', marginLeft: 8 }}>{opt.sub}</span>
                </div>
              ))}
            </div>
            <div
              onClick={() => set('trial', !form.trial)}
              style={{
                padding: '14px 18px', borderRadius: 10, cursor: 'pointer',
                background: form.trial ? 'rgba(16,185,129,0.1)' : 'var(--bg)',
                border: `1px solid ${form.trial ? '#10b981' : 'var(--border)'}`,
              }}
            >
              <span style={{ fontWeight: 700, color: form.trial ? '#10b981' : 'var(--text)' }}>
                {form.trial ? '✓ ' : ''}Trial rejim (7 kun bepul)
              </span>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>Birinchi 7 kun sinov muddati sifatida</div>
            </div>
          </>
        )}

        {/* Step 3: Tasdiqlash */}
        {step === 3 && (
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 16 }}>Ma'lumotlarni tekshiring</div>
            {[
              ['Klub nomi', form.lab_name],
              ['Shahar', form.city || '—'],
              ['Manzil', form.address || '—'],
              ['Kompyuterlar', form.computers_count + ' ta'],
              ['Egasi', form.owner_name],
              ['Telefon', form.owner_phone],
              ['Email', form.owner_email || '—'],
              ['Parol', form.owner_password ? '(kiritilgan)' : '(avtomatik yaratiladi)'],
              ['Obuna rejasi', form.plan],
              ['Trial', form.trial ? 'Ha (7 kun)' : 'Yo\'q'],
            ].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--text3)', fontSize: 13 }}>{k}</span>
                <span style={{ fontWeight: 700, fontSize: 13 }}>{v}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
        {step > 0 && (
          <button onClick={() => setStep(s => s - 1)} style={{
            padding: '10px 24px', borderRadius: 10, cursor: 'pointer', fontWeight: 700,
            background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text2)',
          }}>← Orqaga</button>
        )}
        {step < 3 ? (
          <button onClick={() => {
            if (step === 0 && !form.lab_name.trim()) return setError('Klub nomi majburiy');
            if (step === 1 && (!form.owner_name.trim() || !form.owner_phone.trim())) return setError('Ism va telefon majburiy');
            setError('');
            setStep(s => s + 1);
          }} style={{
            padding: '10px 24px', borderRadius: 10, cursor: 'pointer', fontWeight: 700,
            background: 'rgba(245,158,11,0.15)', border: '1px solid #f59e0b', color: '#f59e0b',
          }}>Keyingi →</button>
        ) : (
          <button onClick={submit} disabled={loading} style={{
            padding: '10px 28px', borderRadius: 10, cursor: 'pointer', fontWeight: 800,
            background: loading ? 'var(--bg2)' : 'rgba(16,185,129,0.2)', border: '1px solid #10b981', color: '#10b981',
          }}>{loading ? 'Yaratilmoqda...' : '✅ Yaratish'}</button>
        )}
      </div>
    </div>
  );
}
